export default "__VITE_ASSET__BM_RMGPp__";